(function () {
  function openModal() {
    const modal = document.getElementById('enquire-modal');
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
    const firstInput = modal.querySelector('input, textarea');
    if (firstInput) setTimeout(() => firstInput.focus(), 50);
  }

  function closeModal() {
    const modal = document.getElementById('enquire-modal');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-enquire-btn]')) {
      openModal();
      return;
    }
    if (e.target.closest('[data-modal-close]') || e.target.id === 'enquire-modal') {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // AJAX form submission
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form.id !== 'EnquireForm') return;

    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    submitBtn.disabled = true;

    fetch('/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new URLSearchParams(new FormData(form)).toString(),
    })
      .then((response) => {
        if (response.ok) {
          document.querySelector('.enquire-modal__fields').innerHTML =
            '<div class="enquire-modal__success"><p>Thank you for your enquiry. We\'ll be in touch soon.</p></div>';
          setTimeout(closeModal, 3000);
        } else {
          submitBtn.disabled = false;
        }
      })
      .catch(() => {
        submitBtn.disabled = false;
      });
  });
})();
